import { useFind } from 'src/api/APIHooks';
import { selectUniqueDisplayValues } from '../utils/selectUniqueDisplayValues';
import useFindCurrentEmployeesFeeScheduleIds from './useFindCurrentEmployeesFeeScheduleIds';

const useInvoiceDisputeReasonOptions = () => {
  const feeScheduleIds = useFindCurrentEmployeesFeeScheduleIds();
  const { data } = useFind(
    'invoice_dispute_reason',
    {
      fee_schedule: feeScheduleIds.join(),
    },
    {
      queryConfig: {
        enabled: feeScheduleIds.length > 0,
        placeholderData: undefined,
      },
    },
  );

  return selectUniqueDisplayValues(data?.data?.data);
};

export default useInvoiceDisputeReasonOptions;
